import {
  CLIENT_LOADING,
  CLIENT_END_LOADING,
  CLIENT_LOADING_OPERATION,
  CLIENT_END_LOADING_OPERATION,
  CLIENT_GET_DATA,
  CLIENT_GET_SINGLE,
  CLIENT_UPDATE_SINGLE,
  CLIENT_REMOVE_SINGLE,
  CLIENT_CLEAR,
  CLIENT_ADD_SINGLE,
  CLIENT_GET_ELEMENTS,
} from "../redux/types";

import * as api from "./api";

/**
 * Obtiene todos los clientes para administracion
 */
export const getAllClients =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/clients/get_all",
      loadingType: CLIENT_LOADING,
      successType: CLIENT_GET_DATA,
      errorType: CLIENT_END_LOADING,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Obtener todos los clientes sin paginacion
 */
export const getAbsClients =
  (callbackFN = null) =>
  async (dispatch) => {
    const response = await api.get(dispatch, {
      url: "/clients/get_abs_all",
      loadingType: CLIENT_LOADING,
      successType: CLIENT_GET_ELEMENTS,
      errorType: CLIENT_END_LOADING,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Crea un nuevo cliente desde administracion
 */
export const createClient =
  (data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/clients/create",
      loadingType: CLIENT_LOADING_OPERATION,
      successType: CLIENT_ADD_SINGLE,
      errorType: CLIENT_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Edita un cliente desde administracion
 */
export const editClient =
  (id_user, data = null, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: `/clients/update/${id_user}`,
      loadingType: CLIENT_LOADING_OPERATION,
      successType: CLIENT_UPDATE_SINGLE,
      errorType: CLIENT_END_LOADING_OPERATION,
      data,
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Elimina un cliente desde administracion
 */
export const deleteClient =
  (id_client, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.deletefn(dispatch, {
      url: `/clients/delete/${id_client}`,
      loadingType: CLIENT_LOADING_OPERATION,
      successType: CLIENT_REMOVE_SINGLE,
      errorType: CLIENT_END_LOADING_OPERATION,
      successPayload: {
        id: id_client,
      },
    });
    if (callbackFN && response) callbackFN(response.success || false);
  };

/**
 * Ingresar la informacion de un cliente para su edicion
 */
export const setClientEditFromFunction = (data) => (dispatch) => {
  dispatch({
    type: CLIENT_GET_SINGLE,
    payload: data,
  });
};
